import { X } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

const Modal = ({ open, onClose, title, children, width = 560 }) => {
  const { dark } = useTheme();
  if (!open) return null;
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div onClick={onClose} style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(4px)' }} />
      <div style={{
        position: 'relative', background: dark ? '#1E293B' : '#fff', borderRadius: 16,
        width: '90%', maxWidth: width, maxHeight: '85vh', overflow: 'auto',
        boxShadow: '0 25px 50px rgba(0,0,0,0.25)',
      }}>
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          padding: '16px 24px', borderBottom: `1px solid ${dark ? '#334155' : '#E2E8F0'}`,
          position: 'sticky', top: 0, background: dark ? '#1E293B' : '#fff', zIndex: 1,
        }}>
          <h3 style={{ margin: 0, fontSize: 17, fontWeight: 600, color: dark ? '#F1F5F9' : '#0F172A' }}>{title}</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 4, borderRadius: 6, color: dark ? '#94A3B8' : '#64748B' }}>
            <X size={18} />
          </button>
        </div>
        <div style={{ padding: 24 }}>{children}</div>
      </div>
    </div>
  );
};

export default Modal;
